// extracted by css-extract-rspack-plugin
var _1 = "ItemIconPlaceholder-m_placeholderBadge-ibyibXI7";
export { _1 as "placeholderBadge" }
